/**
 * Human-readable byte size formatter used in the dialog footer.
 *
 * Returns `null` for unknown sizes so callers can `formatBytes(size) ?? ""`
 * without sprinkling fallbacks. Matches the size strings the file-preview
 * dialogs displayed before unification.
 */
const UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

export function formatBytes(size: number | undefined | null): string | null {
  if (size == null || Number.isNaN(size)) return null;
  if (size < 1) return "0 B";

  const exponent = Math.min(
    Math.floor(Math.log(size) / Math.log(1024)),
    UNITS.length - 1,
  );
  const value = size / Math.pow(1024, exponent);
  return `${value.toFixed(exponent === 0 ? 0 : 1)} ${UNITS[exponent]}`;
}
